import React from 'react';
import GenericPropertiesControl from './GenericPropertiesControl';
import { useTopographyPropertiesStore } from '../../../store/useGeometryPropertiesStore';

const TopographyPropertiesControl = () => {
  const store = useTopographyPropertiesStore();

  
  const properties = [
    { key: 'breitengrad', label: 'Breitengrad (Ursprung)', value: store.breitengrad },
    { key: 'laengengrad', label: 'Längengrad  (Ursprung)', value: store.laengengrad },
    { key: 'nhn', label: '	Höhe am Ursprung (NHN)', value: store.nhn },
    { key: 'referenceSystem', label: 'Höhenreferenzsysteme', value: store.referenceSystem }
  ];

  const handlePropertyUpdate = (key, value) => {
    store.updateProperty(key, value);
  };

  return (
    <GenericPropertiesControl 
      properties={properties}
      onPropertyUpdate={handlePropertyUpdate}
      title="EIGENSCHAFTEN"
    />
  );
};

export default TopographyPropertiesControl;